import classNames from 'classnames'
import * as React from 'react'
import './Tabs.scss'

export enum TabType {
  normal = 'normal',
  giftcard = 'giftcard',
  grey = 'grey',
}

interface TabProps {
  type?: TabType
  children?: React.ReactNode | undefined
}

const Tabs: React.FC<TabProps> = ({ children, type }) => {
  const className = classNames('srprs-tabs', type ? `type-${type}` : '')

  return (
    <div className={className}>
      <ul>{children}</ul>
      <div className="line" />
    </div>
  )
}

interface TabsItemProps {
  label: JSX.Element | string
  active?: boolean
  new?: boolean
  onClick?: () => void
  children?: React.ReactNode | undefined
}

const TabItem: React.FC<TabsItemProps> = props => {
  const classes = classNames(
    props.active && `is-current`,
    props.new && 'is-new',
  )

  return (
    <li className={classes} onClick={props.onClick}>
      <span>{props.label}</span>
      {props.children}
    </li>
  )
}

export { Tabs, TabItem }
